import { render } from "./MobileDevicesNotSupportedMessage.vue?vue&type=template&id=25791911"
import script from "./MobileDevicesNotSupportedMessage.vue?vue&type=script&lang=js"
export * from "./MobileDevicesNotSupportedMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__